<div class='pace pace-inactive'>
  <div class="pace-progress"></div>
</div>